import * as S from './styles';
import { getCampaignColors } from '../../utils/getCampaignColors';

function ThemeButton({ className, children, onClick, disabled }, props) {
  const campaignColors = getCampaignColors();
  
  const searchColor = campaignColors.searchColor;

		const getDynamicStyles = () => {
			const baseStyles = {};

			if (searchColor) {
				if (
					className?.includes('pesquisa') ||
					className?.includes('login') ||
					className?.includes('payment') ||
					className?.includes('close') ||
					className?.includes('choose-entertainment') ||
					className?.includes('choose-available-entertainment')
				) {
					baseStyles.backgroundColor = searchColor;
				}

				if (className?.includes('submit1') || className?.includes('close')) {
					baseStyles.color = searchColor;
				}

				if (className?.includes('close')) {
					baseStyles.borderColor = searchColor;
				}
			}

			return baseStyles;
		};

  return (
    <S.ThemeButton
      {...props}
      disabled={disabled}
      onClick={onClick}
      className={`${className} ${disabled ? 'disabled' : ''}`}
      style={getDynamicStyles()}
    >
      {children}
    </S.ThemeButton>
  );
}

export default ThemeButton;
